<template>
    <div>
        <modal class="new-modal-default add-new-camp-cont"  :name="modal_name"  transition="nice-modal-fade" :delay="100"  :width="750" :height="420" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <!-- Header Section -->
                <div class="v-modal-header">
                    <span class="v-modal-dialog-title v-modal-title">Add New Content</span>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideAddNewContent()"></span>
                    </div>
                </div>
                <!-- Content Body Section -->
                <div class="v-modal-body overflow-x-auto" style="height: 300px;">
                    <div class="v-modal-layout px-3 py-2">
                        <div class="mt-2 w-100 h-line">
                            <span class="bg-white h-label">Add Content Details</span>
                        </div>
                        <div class="mt-5 w-100 mb-5">
                            <span class="bg-white note-algn">Note : Dates which are not selected below will have the content of selected Start Date</span>
                        </div>
                        <div v-for="(content, content_index) in content_details" :key="content_index">
                            <div class="card-background pt-2 pb-5 mb-3">
                                <div class="row pl-5 pr-5">
                                    <div v-if="content_index != 0" class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="add-new pointer" @click="removeStage(content_index, content)">
                                            <img src="/static/images/Delete.png" width="15px"/>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-12">
                                        <div class="w-100">
                                            <span class="input-label">Select Date</span>
                                            <div class="d-flex align-items-center mt-2">
                                                <!-- <date-picker v-model="content.start_date" name="start_date"
                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                    :not-before="template_data.start_date"
                                                    :not-after="template_data.end_date"
                                                    :disabled="content_index == 0"
                                                    format="YYYY-MM-DD" value-type="format" type="date" lang="en" @change="selectDate($event, content_index)"
                                                    :clearable="false" :editable="false">
                                                </date-picker> -->
                                                <datepicker v-model="content.start_date" name="start_date"
                                                    class="camp-add-new-content-date calendar-button-icon"
                                                    placeholder="Select Date" format="yyyy-MM-dd"
                                                    :disabled="content_index == 0"
                                                    @selected="selectDate($event, content_index)"
                                                    :disabled-dates="state.disabledDates">
                                                </datepicker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-12" :class="{'dis-none':content_index == 0}">
                                        <div class="w-100">
                                            <span class="input-label">Add New Content</span>
                                            <div class="d-flex align-items-center mt-4">
                                                <input type="radio" id="new" :name="'new'+content_index" :value="'new'+content_index" v-model="content.content_radio" @change="callRadioValueChange($event, content_index, content)">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-12" :class="{'dis-none':content_index == 0}">
                                        <div class="w-100">
                                            <span class="input-label">Copy Content from</span>
                                            <div class="d-flex align-items-center mt-2">
                                                <input type="radio" id="copy" :disabled="content_index == 0" :name="'copy'+content_index" :value="'copy'+content_index" v-model="content.content_radio" @change="callRadioValueChange($event, content_index, content)">
                                                <multiselect
                                                    class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow ml-3"
                                                    :searchable="true" v-model="content.copy_content" :options="date_list_options"
                                                    :disabled="content.content_radio == 'new'+content_index || content.content_radio == ''"
                                                    placeholder="Select Content from">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row pl-9 pr-9">
                                    <div class="col-lg-5 col-md-5 col-sm-12" style="display: contents;" v-if="content.selected_dates.length > 0">
                                        <div v-for="(selected, selected_dates_index) in content.selected_dates" :key="selected_dates_index">
                                            <span v-if="content_index == 0" class="custom__tag mt-2">
                                                <span>{{ selected }}</span>
                                                <span v-if="selected_dates_index !=0" class="custom__remove"
                                                    @click="removeDateTag(selected, content_index)">
                                                    <i class="icon-close iconsize-16 default-white"></i>
                                                </span>
                                            </span>
                                            <span v-else class="custom__tag mt-2">
                                                <span>{{ selected }}</span>
                                                <span class="custom__remove"
                                                    @click="removeDateTag(selected, content_index)">
                                                    <i class="icon-close iconsize-16 default-white"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="mt-5 add-new">
                                <span class="fw-600 pointer" @click="addNew()">+Add New</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Footer Section -->
                <div class="v-modal-footer mb-4">
                    <div class="d-flex  align-items-center justify-content-center ">
                        <button class="btn new-cancel-button" @click="hideAddNewContent()">Cancel</button>
                        <button class="btn new-save-button ml-6" @click="saveData()">Submit</button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { EventBus } from '../../eventBus/nav-bar-event';
import { SweetModal } from 'sweet-modal-vue';
export default {
    data(){
        return{
            success_msg: '',
            warning_msg: '',
            content_details: [],
            date_list_options: [],
            template_data:[],
            template_details: [],
            is_all_fields_filled: true,
            state:{
                disabledDates:{
                    to: '',
                    from: '',
                    days: [],
                    daysOfMonth: [],
                }
            }
        }
    },
    props: ["modal_name"],
    components: {
        SweetModal,
        Datepicker,
    },
    methods:{
        //Method to perform when radio button value changes
        callRadioValueChange(data, index, content){
            if(data.target._value.startsWith("new")){
                this.content_details[index].copy_content = ""
            }
            if(content.content_radio.startsWith("copy")){
                this.date_list_options.forEach((el_date_list, el_date_list_index) => {
                    if(el_date_list === content.selected_dates[0]){
                        this.date_list_options.splice(el_date_list_index, 1)
                    }
                }) 
                this.content_details.forEach((el_reset, el_reset_index) => {
                    if(el_reset.copy_content === content.selected_dates[0]){
                        el_reset.copy_content = ""
                    }
                })
            } else if(content.content_radio.startsWith("new")){
                this.date_list_options.push(content.selected_dates[0])
            }
        },
        //According to selected dates it formats campaign templates and redirect to create page
        saveData(){
            this.content_details.forEach((el_check, el_check_index) => {
                if(el_check_index != 0){
                    if(el_check.content_radio.startsWith('new') && el_check.selected_dates.length == 0){
                        this.is_all_fields_filled = false;
                    } else if(el_check.content_radio.startsWith('copy') && (el_check.copy_content == "" || el_check.selected_dates.length == 0)){
                        this.is_all_fields_filled = false;
                    } else {
                        this.is_all_fields_filled = true;
                    }
                }
            })
            if(this.is_all_fields_filled == false){
                this.warning_msg = 'Please Fill All The Fields'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            } else {
                this.template_details = []
                this.content_details.forEach((el) => {
                    if(el.content_radio.startsWith('new')){
                            this.template_details.push({
                                template_dates: el.selected_dates,
                                topic_name: "",
                                headline_url: "",
                                add_url: "",
                                headline: "",
                                content: "",
                                phone_number: {
                                    number: "",
                                    code: ""
                                },
                                meeting_location_vmodel: "",
                                location:{
                                    address_type: "mailing_address",
                                    building_number: "",
                                    street:'',
                                    city:'',
                                    township:'',
                                    state:'',
                                    country:'',
                                    zip_code:'',
                                    latitude:'',
                                    longitude:'',
                                },
                                facebook_url: "",
                                twitter_url: "",
                                insta_url: "",
                                linkedin_url: "",
                                logoImage: [],
                                bannerImage: [],
                                showLogoImageUpload: true,
                                showBannerImageUpload: true,
                                content_radio: 'new',
                                copy_content: el.copy_content,
                            })
                    } else if(el.content_radio.startsWith('copy')){
                        this.template_details.forEach(el_one => {
                            el_one.template_dates.forEach(el_two => {
                                if(el.copy_content === el_two){
                                    el.selected_dates.forEach(el_three => {
                                        el_one.template_dates.push(el_three)
                                    })
                                }
                            })
                        })
                    }
                    this.template_details.forEach((el_four, el_four_index) => {
                        el_four.content_radio = 'new'+el_four_index
                    })
                })
                this.template_data.template_details.forEach((data, data_index) => {
                    if(data_index < this.template_details.length){    
                        this.template_details[data_index].topic_name = data.topic_name
                        this.template_details[data_index].headline_url = data.headline_url
                        this.template_details[data_index].add_url = data.add_url
                        this.template_details[data_index].headline = data.headline
                        this.template_details[data_index].content = data.content
                        this.template_details[data_index].phone_number = data.phone_number
                        this.template_details[data_index].meeting_location_vmodel = data.meeting_location_vmodel
                        this.template_details[data_index].location = data.location
                        this.template_details[data_index].facebook_url = data.facebook_url
                        this.template_details[data_index].twitter_url = data.twitter_url
                        this.template_details[data_index].insta_url = data.insta_url
                        this.template_details[data_index].linkedin_url = data.linkedin_url
                        this.template_details[data_index].logoImage = data.logoImage
                        this.template_details[data_index].bannerImage = data.bannerImage
                        this.template_details[data_index].showLogoImageUpload = data.showLogoImageUpload
                        this.template_details[data_index].showBannerImageUpload = data.showBannerImageUpload
                    }
                })
                localStorage.removeItem("add_new_content")
                EventBus.$emit("new_content", this.template_details)
                this.hideAddNewContent();
            }
        },
        //Deletes selected date
        removeDateTag(option, index){
            this.content_details[index].selected_dates.forEach((el, option_index) => {
                if(el === option){
                    this.content_details[index].selected_dates.splice(option_index, 1)
                    if(option_index == 0){
                        this.date_list_options.forEach((el_date_list, el_date_list_index) => {
                            if(el_date_list === option){
                                this.date_list_options.splice(el_date_list_index, 1)
                                this.content_details.forEach((el_reset_date, el_reset_index) => {
                                    if(el_reset_date.copy_content === option){
                                        el_reset_date.copy_content = ""
                                    }
                                })
                            }
                        })
                        if(this.content_details[index].selected_dates.length > 0){
                            this.date_list_options.push(this.content_details[index].selected_dates[0])
                        }
                    }
                }
            })         
        },
        //Checks selected date already exist or not
        selectDate(data, index){
            let formatted_date = ''
            formatted_date = moment(data.toUTCString()).format("YYYY-MM-DD")
            let is_exits = false
            this.content_details.forEach((select_date_one) => {
                select_date_one.selected_dates.forEach((select_date_two) => {
                    if(select_date_two === formatted_date){
                        is_exits = true;
                        this.warning_msg = 'Campaign Already Exists For Selected Date'
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.content_details[index].start_date = ''
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                })
            })
            if(is_exits == false){
                this.content_details[index].selected_dates.push(formatted_date)
                if(this.content_details[index].selected_dates.length == 1 && this.content_details[index].content_radio.startsWith("new")){
                    this.date_list_options.push(this.content_details[index].selected_dates[0])
                }
                setTimeout(() => {
                    this.content_details[index].start_date = ''
                }, 500);
            }
            this.$forceUpdate();
        },
        hideAddNewContent() {
            this.$modal.hide(this.modal_name)
            this.$emit('hideAddNewContent')
        },
        //Adds new date field
        addNew(){
            let index = this.content_details.length
            this.content_details.push({
                start_date: '',
                content_radio: 'new'+index,
                copy_content: '',
                selected_dates: [],
            });
        },
        //Deletes added dates stage
        removeStage(index, content){
            this.content_details.splice(index, 1);
            if(content.content_radio.startsWith('new')){
                this.template_data.template_details.forEach((parent_element, parent_index) => {
                    parent_element.template_dates.forEach((child_element) => {
                        if(content.selected_dates[0] === child_element){
                            this.template_data.template_details.splice(parent_index, 1);
                        }
                    })
                })
            }
            this.date_list_options.forEach((date_list, date_list_index) => {
                if(content.selected_dates[0] == date_list){
                    this.date_list_options.splice(date_list_index, 1)
                }
            })
            this.content_details.forEach((copy_del, copy_del_index) => {
                if(copy_del.copy_content == content.selected_dates[0]){
                    copy_del.copy_content = ""
                }
            })
            this.content_details.forEach((el, el_index) => {
                if(el_index >= index){
                    let temp_radio_value = ""
                    if(el.content_radio.startsWith("new")){
                        temp_radio_value = 'new' + el_index
                    } else if(el.content_radio.startsWith("copy")){
                        temp_radio_value = 'copy' + el_index
                    }
                    this.content_details[el_index].content_radio = ""
                    this.content_details[el_index].content_radio = temp_radio_value
                }
            })
        },
        //loads template data from create campaign page which is stored in local
        loadTemplateDetails(){
            this.template_data = JSON.parse(localStorage.getItem("add_new_content"))
            let endDate = new Date(this.template_data.end_date)
            endDate.setDate(endDate.getDate() + 1);
            this.state.disabledDates.to = new Date(this.template_data.start_date)
            this.state.disabledDates.from = endDate
            //To enable only selected day in a week
            if(this.template_data.recurrence_days == "Weekly"){
                let days = [0, 1, 2, 3, 4, 5, 6]
                let day_of_week = moment(this.template_data.start_date).format("E")
                if(day_of_week == 7){
                    day_of_week = 0
                }
                days.forEach((selected_day_of_week, day_of_week_index) => {
                    if(selected_day_of_week == day_of_week){
                        days.splice(day_of_week_index, 1)
                    }
                })
                this.state.disabledDates.days = days;
            }
            //To enable only selected day in a month
            if(this.template_data.recurrence_days == "Monthly"){
                let monthDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
                let day_of_month = moment(this.template_data.start_date).format("D")
                monthDays.forEach((selected_day_of_month, day_of_month_index) => {
                    if(selected_day_of_month == day_of_month){
                        monthDays.splice(day_of_month_index, 1)
                    }
                })
                this.state.disabledDates.daysOfMonth = monthDays;
            }
            this.template_data.template_details.forEach(el => {
                if(el.template_dates.length == 1){
                    this.content_details.push({
                        start_date: '',
                        content_radio: 'new',
                        copy_content: el.copy_content,
                        selected_dates: el.template_dates,
                    })
                    el.template_dates.forEach(dates => {
                        this.date_list_options.push(dates)
                    })
                } else if(el.template_dates.length > 1){
                    this.content_details.push({
                        start_date: '',
                        content_radio: 'new',
                        copy_content: el.copy_content,
                        selected_dates: el.template_dates,
                    })
                    this.date_list_options.push(el.template_dates[0])
                }
            })
            this.content_details.forEach((content_el, content_el_index) => {
                content_el.content_radio = content_el.content_radio + content_el_index
            })
            this.$forceUpdate();
        },
    },
    mounted(){
        this.loadTemplateDetails();
    },
}
</script>
<style scoped>
.card-background {
    background-color: #f8f8f8;
    border-radius: 8px;
}
.add-new{
    font-size: 14px;
    color: #00448b;
    text-align: right !important;
}
.h-line{
    height: 12px;
    border-bottom: 2px solid #ccc;
    text-align: left
}
.h-label{
    padding-right:10px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 0.39px;
    text-align: left;
    color: #00448b;
    font-size: 14px;
}
.input-label {
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 0.39px;
    text-align: left;
    color: #00448b;
    padding: 0 0 6px 0px;
    font-size: 14px;
}
input[type=radio] {
    width: 2em;
    height: 2em;
    accent-color: #00448b !important;
}
.custom__tag {
    display: inline-flex;
    padding: 3px 12px;
    background: #00448b;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 12.5px;
    cursor: pointer;
    color: #ffffff;
}
.default-white {
    color: #ffffff;
}
.dis-none{
    display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Campaign/Email/AddNewContent.vue